import PepeLogo from "@/components/PepeLogo";

export default function Footer({ onNavigate }) {
  return (
    <footer data-testid="footer" className="border-t border-line bg-surface">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8">
        <div className="flex flex-col justify-between gap-10 md:flex-row md:items-start">
          <div>
            <button
              data-testid="footer-logo"
              onClick={() => onNavigate("#top")}
              className="flex items-center gap-3"
            >
              <PepeLogo className="h-10 w-10" />
              <span className="font-display text-base font-extrabold tracking-widest text-neon">
                PEPE BUTT
              </span>
            </button>
            <p className="mt-4 max-w-sm font-mono text-xs leading-relaxed text-[#6b7f6b]">
              $PEPEBUTT is a meme coin created for entertainment, with no
              intrinsic value or expectation of financial return. Always do
              your own research — and never look away when he turns around.
            </p>
          </div>
          <div className="flex flex-col gap-3 font-mono text-xs tracking-[0.2em] uppercase">
            <a
              data-testid="footer-x-link"
              href="https://x.com/PEPEBUTTCOIN"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#9fb39f] transition-colors duration-200 hover:text-neon"
            >
              X / @PEPEBUTTCOIN
            </a>
            <a
              data-testid="footer-telegram-link"
              href="https://t.me/PEPEBUTTGROUP"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#9fb39f] transition-colors duration-200 hover:text-neon"
            >
              TELEGRAM / PEPEBUTTGROUP
            </a>
            <button
              data-testid="footer-how-to-buy-link"
              onClick={() => onNavigate("#how-to-buy")}
              className="text-left text-[#9fb39f] transition-colors duration-200 hover:text-neon"
            >
              HOW TO BUY
            </button>
            <button
              data-testid="footer-tokenomics-link"
              onClick={() => onNavigate("#tokenomics")}
              className="text-left text-[#9fb39f] transition-colors duration-200 hover:text-neon"
            >
              TOKENOMICS
            </button>
            <button
              data-testid="footer-community-link"
              onClick={() => onNavigate("#community")}
              className="text-left text-[#9fb39f] transition-colors duration-200 hover:text-neon"
            >
              COMMUNITY
            </button>
          </div>
        </div>
        <div className="mt-12 flex flex-wrap items-center justify-between gap-4 border-t border-line pt-6 font-mono text-[10px] tracking-[0.25em] text-[#6b7f6b] uppercase">
          <span>© 2026 PEPE BUTT — $PEPEBUTT</span>
          <span className="animate-flicker">CHEEK. CHEEK. CHEEK.</span>
        </div>
      </div>
    </footer>
  );
}
